import { useMutation, useQueryClient } from "@tanstack/react-query";
import { startExtraction, type StartExtractionRequest } from "../api/extractions";

export function useStartExtraction(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body?: StartExtractionRequest) => startExtraction(projectId, body ?? {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["project", projectId] });
      qc.invalidateQueries({ queryKey: ["extractions", projectId] });
    },
  });
}
